import { swSettings } from "app/common/services/swSettings";
import type { INavItem } from "../../../types";
import { isLocked } from "app/common/services/pageClaims";
import { applyNavItemPermissions } from "app/pages/workspace/common/workspacesUtils";
import { ESecondaryItemType } from "@similarweb/ui-components";
import { SecondaryItem } from "@similarweb/ui-components";

export const backlinksAnalysisNavObj = (): { navList: INavItem[] } => {
    return {
        navList: [
            {
                id: "backlinks_overview",
                name: "digitalsuite_backlinks_overview",
                title: "digitalsuite.backlinks.overview.title",
                state: "digitalsuite_backlinks_overview",
                lockIcon: isLocked(swSettings.components.Backlinks),
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                id: "backlinks_domains",
                name: "digitalsuite_backlinks_domains",
                title: "digitalsuite.backlinks.refdomains.title",
                state: "digitalsuite_backlinks_domains",
                lockIcon: isLocked(swSettings.components.Backlinks),
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
            {
                id: "backlinks_table",
                name: "digitalsuite_backlinks_table",
                title: "digitalsuite.backlinks.table.title",
                state: "digitalsuite_backlinks_table",
                lockIcon: isLocked(swSettings.components.Backlinks),
                itemComponent: SecondaryItem,
                itemType: ESecondaryItemType.Standalone,
            },
        ].map(applyNavItemPermissions),
    };
};
